import { useDashboardChartFormProcess } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { SelectExercisePage } from '#pages/SelectExercisePage/page';
import { SelectPresetsPage } from '#pages/SelectPresets/page';
import { DashboardChartForm } from './components/DashboardChartForm';

export const DashboardChartFormPage = () => {
  const { tab } = useDashboardChartFormProcess();

  return (
    <>
      {tab === '운동 선택' && <SelectExercisePage />}
      {tab === '프리셋 선택' && <SelectPresetsPage />}
      {tab === '폼' && <DashboardChartForm />}
    </>
  );
};
